export function formatDateToYMD(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const utc = new Date(d.getTime() - d.getTimezoneOffset() * 60000);

  const y = utc.getUTCFullYear();
  const m = String(utc.getUTCMonth() + 1).padStart(2, "0");
  const day = String(utc.getUTCDate()).padStart(2, "0");

  return `${y}-${m}-${day}`;
}
